// rolesReducer.js
import {
    FETCH_ROLES_SUCCESS,
    FETCH_ROLES_FAILURE,
    FETCH_ROLE_SUCCESS,
    FETCH_ROLE_FAILURE,
    CREATE_ROLE_SUCCESS,
    CREATE_ROLE_FAILURE,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_FAILURE,
    DELETE_ROLE_SUCCESS,
    DELETE_ROLE_FAILURE,
} from './types';

const initialState = {
    roles: [],
    role: null,
    error: "",
};

export function rolesReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                error: "",
            };
        case FETCH_ROLES_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case FETCH_ROLE_SUCCESS:
            return {
                ...state,
                role: action.payload,
                error: "",
            };
        case FETCH_ROLE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case CREATE_ROLE_SUCCESS:
            return {
                ...state,
                roles: [...state.roles, action.payload],
                error: "",
            };
        case CREATE_ROLE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case UPDATE_ROLE_SUCCESS:
            return {
                ...state,
                roles: state.roles.map((role) =>
                    role._id === action.payload._id ? action.payload : role
                ),
                error: "",
            };
        case UPDATE_ROLE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_ROLE_SUCCESS:
            return {
                ...state,
                roles: state.roles.filter((role) => role._id !== action.payload),
                error: "",
            };
        case DELETE_ROLE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
